import React, { Fragment } from 'react';
import {
  Table,
  Collapse,
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
} from 'reactstrap';
import shortid from 'shortid';

import { Form, FormGroup, Label, Input } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FormGroup as LocalFormGroup } from 'components/common/Forms';
import { LocalForm, Control, actions, Errors } from 'react-redux-form';
import _ from 'lodash';
import { TableContainer } from 'components/common/Tables';
import { 
  PendingButton
 ,withResolver
 ,withDebug
 ,withModal 
} from 'components/common';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import moment from 'moment';
import Select from 'react-select';
import { partition, keyBy, remove, map, find, defaultTo } from 'lodash';
import { NotificationManager } from 'react-notifications';
import { 
  compose
, withPropsOnChange
, withState
, withHandlers
, withProps 
} from 'recompose';
import DatePicker from 'react-datepicker';
import { ApiClient } from 'services';

const removeUnassignable = (jobList, allJobs) => {
  // I know... sorry. This just converts the weird-ass format we get passed into an actual
  // array of job objects. jobList is actually a single object with each property the id of 
  // a job... why? I don't know. 
  const jobs = _.filter(allJobs, (o) => (_.filter(Object.keys(jobList), (k) => (k == o.id)).length > 0));
  const removeJobs =  _.filter(jobs, (j) => j.job_status < 50);
  return _.map(removeJobs, (j) => parseInt(j.id));
};

export const OrdersItem = ({
  item,
  open,
  client,
  toggleCollapse,
  installers,
  doAssignList,
  setDoAssignList,
  doAssignTechList,
  setDoAssignTechList,
  selectedTech,
  setSelectedTech,
  isInstaller,
  selectedInstaller,
  setSelectedInstaller,
  selectedStatus,
  setSelectedStatus,
  refresh,
  setRefresh,
  assignInstaller,
  saveEnabled,
  onInstallerChange,
  canAssign,
  canAccept,
  onAccept,
  onReject,
  toggleModal,
  isModalOpen,
  comments,
  icon,
  jobIcon,
  setComments,
  setReason,
  rejectionReasons,
  acceptPending,
  canManage,
  canView,
  canChangeStatus,
  onStatusChange,
  jobStatuses,
  setJobStatuses,
  setJobSubStatuses,
  displayCountry = true,
  showCompletedAt = false,
  showCreatedAt = true,
  showOrderStatus = true,
  hasNoShow,
  statuses,
  onBookedDateChange,
  onCompletedDateChange,
}) => (
  <Card style={{ marginBottom: '10px', backgroundColor: item.is_switchover ? '#4ba2db' : undefined }}>
    <CardHeader>
      <Row onClick={() => toggleCollapse(item.id)}>
        <Col>
          <div>
            {hasNoShow && String.fromCharCode("0x26a0")}
            <strong>&nbsp;Order Ref:</strong> {item.order_ref}
          </div>
          {item.tracking_ref && <div><strong> Tracking Ref: </strong> {item.tracking_ref}</div>}
        </Col>
        {icon && <Col>{icon(item)}</Col>}
        <Col>
          <strong>Surrogate ID:</strong> {item.customer_surrogate_id}
        </Col>
        <Col>
          <strong>Company Name:</strong> {item.company_name}
        </Col>
        <Col>
          <strong>Town/City:</strong> {item.city}
        </Col>
        <Col>
          <strong>Postcode:</strong> {item.postcode}
        </Col>
        <Col>
          <strong>Number of devices:</strong> {_.filter(item.jobs, (o) => !o.duplicate ).length}
        </Col>
        {displayCountry && <Col>
          <strong>Country:</strong> {item.country ? item.country : 'N/A'}
        </Col>}
        <Col>
          {
            showOrderStatus && (<span><strong>Status:</strong> {item.status_text}</span>)
          }
        </Col>
        <Col>
        {(() => {
          switch(true) {
            case showCompletedAt && showCreatedAt:
              return (
              <Fragment>
                {item.jobs.map((j) => {
                  let job_status = j.status_text.toLowerCase();
                  if (job_status && (job_status.includes("complete") || job_status.includes("not required"))) {
                    return (
                      <div><strong>Completed:</strong> <div className="text-nowrap"> {moment(item.updated_at).format('YYYY-MM-DD')} </div> </div>
                    )
                  }
                  return null;
                })}
              <div><strong>Created:</strong> <div className="text-nowrap"> {moment(item.imported_at).format('YYYY-MM-DD')} </div> </div>
              </Fragment>
              );
            case showCompletedAt:
              return <div><strong>Completed:</strong> <div className="text-nowrap"> {moment(item.updated_at).format('YYYY-MM-DD')} </div> </div>;
            case showCreatedAt:
              return <div><strong>Created:</strong> <div className="text-nowrap"> {moment(item.imported_at).format('YYYY-MM-DD')} </div> </div>;
            default:
              return null;
        }
        })()}
        </Col>
        <Col xs="auto">
          <Button color="link" className="float-right p-0">
            <span
              className={classNames('fa', {
                'fa-chevron-down': !open,
                'fa-chevron-up': open,
              })}
            />
          </Button>
        </Col>
      </Row>
    </CardHeader>
    <Collapse isOpen={open}>
      <CardBody>
        <TableContainer 
          items={item.jobs}
          selected={doAssignList}
          onSelectedChanged={setDoAssignList}
        >
          <Table size="sm" style={{ fontSize: '85%' }}>
            <thead>
              <tr>
                <th></th>
                <th select={(isInstaller && !canAccept) || canAssign}/>
                <th></th>
                <th>Job Number</th>
                <th>
                  {item.is_split && !isInstaller &&
                    <div> 
                      Installer
                    </div>
                  }
                </th>
                <th>Job Status</th>
                <th>Booked Date</th>
                <th>Completed Date</th>
                <th>{icon && !!icon(item) && 'SLA'}</th>
                <th>Job Type</th>
                <th>Vehicle Reg</th>
                <th>Make</th>
                <th>IMEI</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {item.jobs.map((j, idx) => (
                <tr key={j.id}>
                  <td>{(j.job_status >= 50 && j.job_status < 70) &&	String.fromCharCode("0x26a0")} </td>
                  <td select={(isInstaller && !canAccept) || canAssign}/>
                  <td/>
                  <td>{j.id}</td>
                  <td> 
                  {
                    j.installer_user && item.is_split ? 
                    defaultTo(find(installers, ['id', j.installer_user]),{name:''}).name:
                    ''
                  } 
                  </td>
                  <td>
                    {canChangeStatus ? (
                      <Select
                        value={j.job_status}
                        simpleValue
                        placeholder={j.status_text}
                        clearable={false}
                        options={jobStatuses}
                        onChange={v => onStatusChange(idx, v)}
                        labelKey="text"
                        className="placeholder-black"
                        searchable={false}
                        style={{ minWidth: 150 }}
                      />
                    ) : (
                      j.status_text
                    )}
                  </td>
                  <td>
                    {canChangeStatus ? (
                      <DatePicker
                        className="form-control"
                        value={j.appointment_date && moment(j.appointment_date).format('YYYY-MM-DD')}
                        onChange={v => onBookedDateChange(idx, v.format('YYYY-MM-DD'))}
                        dateFormat="YYYY-MM-DD"
                        required={j.job_status == "Installation Booked"}
                      />
                    ) : (
                      j.appointment_date
                    )}
                  </td>
                  <td>
                    {canChangeStatus ? (
                      <DatePicker
                        className="form-control"
                        value={j.job_completed_at && moment(j.job_completed_at).format('YYYY-MM-DD')}
                        onChange={v => onCompletedDateChange(idx, v.format('YYYY-MM-DD'))}
                        dateFormat="YYYY-MM-DD"
                        required={j.job_status == "Installation Complete"}
                      />
                    ) : (
                      j.job_completed_at
                    )}
                  </td>
                  <td>{jobIcon && jobIcon(j)}</td>
                  <td>{j.order_job_type}</td>
                  <td>{j.vehicle_registration}</td>
                  <td>{j.make}</td>
                  <td>{j.imei}</td>
                  <td>
                    {(canAssign || canManage) && (
                      <Link to={{pathname: '/manage-job/' + j.id, state: item}}>
                        <Button color="primary" className="float-right">
                          Manage
                        </Button>
                      </Link>
                    )}
                    {!(canAssign || canManage) &&
                      canView && (
                        <Link to={{pathname: '/manage-job/' + j.id, state: item}}>
                          <Button color="primary" className="float-right">
                            View
                          </Button>
                        </Link>
                      )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableContainer>
        {canAssign && Object.keys(doAssignList).length > 0 && (
          <div>
            <Form inline onSubmit={assignInstaller}>
            
              <FormGroup style={{ margin: '10px' }}>
                <Label for="installerSelect">Select an installer: &nbsp;</Label>
                <Input
                  type="select"
                  name="installerSelect"
                  id="installerSelect"
                  onChange={e => setSelectedInstaller(e.target.value)}
                >
                  <option />
                  {installers.map(x => (
                    <option key={x.id} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              
              <FormGroup style={{ margin: '10px' }}>
                <Label for="statusSelect">Status: &nbsp;</Label>
                <Input
                  type="select"
                  name="statusSelect"
                  id="statusSelect"
                  onChange={e => setSelectedStatus(e.target.value)}
                >
                  <option />
                  {statuses.map(x => (
                    <option key={x.value} value={x.value}>
                      {x.text}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              
              <Button color="primary" disabled={selectedInstaller === null} onClick={assignInstaller}>
                Save
              </Button>
              
            </Form>
            {item.rejected_installers.map(i => (
              <p
                key={i.id}
                className="form-text mb-0 text-danger small"
              >{`${moment(i.timestamp).format(
                'YYYY-MM-DD HH:mm'
              )} Rejected by ${i.installer__name}${
                i.comments ? ': ' + i.comments : ''
              }`}</p>
            ))}
          </div>
        )}
        {canAccept && (
          <div>
            <div className="d-flex justify-content-center">
              <div className="p-2 flex-column pull-right">
                <div> <b>Preferred Install Dates:</b> </div>
                <div>{item.date_1 && item.date_1}</div>
                <div>{item.date_2 && item.date_2}</div>
                <div>{item.date_3 && item.date_3}</div>
              </div>
              <PendingButton
                pending={acceptPending}
                color="danger"
                className="mx-2 my-5"
                onClick={(e) => {
                  toggleModal();
                }}
                style={{ minWidth: 150 }}
              >
                Reject
              </PendingButton>
              <PendingButton
                pending={acceptPending}
                color="success"
                className="mx-2 my-5"
                onClick={onAccept}
                style={{ minWidth: 150 }}
              >
                Accept
              </PendingButton>
            </div>
          </div>
        )}
        {isModalOpen && (
          <Modal isOpen={isModalOpen} toggle={toggleModal}>
            <ModalBody>
                Select a reason to reject this order:
                  <LocalFormGroup >
                    <select
                      onChange={e => setReason(e.target.value)}
                      className="form-control"
                    >
                      {rejectionReasons.map(i => (
                        <option key={i.value} value={i.value}>
                          {i.text}
                        </option>
                      ))}
                    </select>
                  </LocalFormGroup>
                  <LocalFormGroup label="Comments">
                    <textarea
                      value={comments}
                      placeholder="if applicable"
                      onChange={e => setComments(e.target.value)}
                      className="form-control"
                      rows="3"
                    />
                  </LocalFormGroup>
            </ModalBody>
            <ModalFooter>
              <PendingButton
                color="primary"
                onClick={(e) => {
                  onReject();
                  toggleModal();
                }}
              >
                Confirm
              </PendingButton>
              <Button color="secondary" onClick={toggleModal}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </CardBody>
    </Collapse>
  </Card>
);

export const enhance = compose(
  withState('selectedInstaller','setSelectedInstaller',null),
  withState('selectedStatus','setSelectedStatus',null),
  withState('doAssignList','setDoAssignList',{}),
  withState('jobStatuses', 'setJobStatuses', []),
  withState('jobSubStatuses', 'setJobSubStatuses', []),
  withState('isCalendarOpen','setIsCalendarOpen',false),
  withProps( props => ({
    toggleCalendarModal : () => props.setIsCalendarOpen(!props.isCalendarOpen),
    hasNoShow: _.filter(props.item.jobs, (i) => i.job_status == 50).length >= 1
  })),
  withModal(),
  withHandlers({
    assignInstaller: ({
      client,
      doAssignList,
      setDoAssignList,
      selectedInstaller,
      item,
      setRefresh,
    }) => event => {
      event.preventDefault();
      const jobIds = map(Object.keys(doAssignList),x => parseInt(x));

      var data = null;
      if (jobIds.length < item.jobs.length) {
         data = {
          job_ids: jobIds,
          installer_id: selectedInstaller,
        };
      } else {
         data = {
          order_id: item.id,
          installer_id: selectedInstaller,
        };
      }

      client
        .post('assign_installer', data)
        .then((response) => {
          NotificationManager.success('Saved');
          // Salesforce toast notification
          if (response.data && response.data.warning) {
            NotificationManager.warning(response.data.warning, 'Salesforce Warning', 15000);
          }
          setRefresh(shortid());
          setDoAssignList({});
        })
        .catch(error => NotificationManager.error(error.response.data.message));
    }
  }),
  withResolver(
    {
      jobStatuses: () => client => client.get('job_statuses_by_type?filter=all'),
      jobStatusesAll: () => client => client.get('job_statuses'),
      jobSubStatuses: () => client => client.get('job_substatuses'),
    },
    {
      onResolved: ({ setJobStatuses, setJobSubStatuses, item }) => ({ jobStatuses, jobStatusesAll, jobSubStatuses }) => {
        var statuses = _.get(_.find(jobStatuses, (obj) => obj.type.value == item.job_type), 'statuses');
        var subStatuses = _.get(_.find(jobSubStatuses, (obj) => obj.type.value == item.job_status), 'subStatuses', []);
        if(statuses.length > 0) {
          setJobStatuses(statuses);
        } else {
          setJobStatuses(jobStatusesAll);
        }
        setJobSubStatuses(subStatuses);
      },
    }
  ),
  withPropsOnChange(['installers'], ({ installers, item }) => {
    if (!installers || !item.rejected_installers) return null;
    const rejectedInstallers = keyBy(item.rejected_installers, 'installer_id');
//    const [unusedInstallers, usedInstallers] = partition(
 //     installers,
//      i => !rejectedInstallers[i.id]
//    );

    return {
//      installers: [...unusedInstallers, ...usedInstallers],
//      displayCountry: true,
    };
  }),
);

export default enhance(OrdersItem);



// WEBPACK FOOTER //
// ./src/pages/Orders/Item.jsx